export const MODAL_VISIBILITY = 'MODAL_VISIBILITY';
export const PICADA_SELECTED = 'PICADA_SELECTED';
export const FETCH_DATA = 'FETCH_DATA';

export const IMAGE = {
  com: '/com/principals.jpg',
  crio: '/crio/principals.jpg',
  ide: '/ide/principals.jpg',
  que: '/que/principals.jpg',
  sab: '/sab/principals.jpg',
  ser: '/ser/principals.jpg',
} 


/** WEBPACK FOOTER **
 ** ./src/constants.js
 **/


/** WEBPACK FOOTER **
 ** ./src/constants.js
 **/